const config = {
    localStorageKey: {
        de: "favorite-store",
        at: "favorite-store",
        ch: "favorite-store",
        pl: "favorite-store-pl",
        cs: "favorite-store-cs",
        da: "favorite-store-da",
        es: "favorite-store-es",
        fr: "favorite-store-fr",
        it: "favorite-store-it",
        nl: "favorite-store-nl",
        ro: "favorite-store-ro",
        sk: "favorite-store-sk",
        sv: "favorite-store-sv",
        uk: "favorite-store-uk",
        us: "favorite-store-us",
    },
};

export default config;
